<template xmlns="http://www.w3.org/1999/html">
  <b-row class="row-gap-2">
    <b-col  md="7" sm="12" order="2" order-sm="2" order-md="1" v-if="isHasSign">
      <b-row>
        <b-col cols="5">
          <b-row class="image-group">
            <b-col cols="12">
              <div class="card-image-container mt-0">
                <div style="position: relative;">
                  <img
                      v-if="!groupImage.profilePicture"
                      src="@/assets/images/videoCall/avatar.png"
                      style="height: 330px"
                      class="video-image"
                  />
                  <v-zoomer>
                    <img
                        v-if="groupImage.profilePicture"
                        :src="groupImage.profilePicture"
                        class="video-image preview-image"
                        :class="invalidInfo.profilePicture ? 'border-red' : ''"
                    />
                  </v-zoomer>

                  <img
                      src="@/assets/images/videoCall/camera.svg"
                      alt=""
                      class="camera-icon"
                      @click="captureScreen('profilePicture')"
                  />
                </div>
                <div class="d-flex">
                  <div
                      class="text-label"
                      :class="isShowFaceWarning ? ' w-75' : 'w-100'"
                  >
                    Ảnh chân dung
                    <p class="font-weight-bolder">
                      Tỉ lệ facematching: {{ cardInfo.faceMatching }}%
                    </p>
                  </div>
                  <div
                      class="d-flex justify-content-center align-items-center"
                      v-if="isShowFaceWarning"
                  >
                    <i
                        class="fa-solid fa-triangle-exclamation"
                        style="color: #ff0000;font-size: 3rem"
                    ></i>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="card-image-container mt-0">
                <div style="position: relative;">
                  <img
                      v-if="!groupImage.frontCMND"
                      src="@/assets/images/videoCall/front-card.png"
                      class="video-image"
                  />
                  <!--                  <img  :src="groupImage.frontCMND" id="zoom" title="Ảnh mặt trước"-->
                  <!--                       class="video-image preview-image MagicZoomPlus" :class="invalidInfo.frontCMND ? 'border-red' : ''"/>-->
                  <div class="image-container" v-if="groupImage.frontCMND">
                    <v-zoomer>
                      <img
                          class="video-image preview-image image-zoom"
                          :src="groupImage.frontCMND"
                      />
                    </v-zoomer>
                    <div class="image-details"></div>
                  </div>

                  <img
                      src="@/assets/images/videoCall/camera.svg"
                      alt=""
                      class="camera-icon"
                      @click="captureScreen('frontCMND')"
                  />
                </div>
                <div class="text-label">Ảnh mặt trước</div>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="card-image-container">
                <div style="position: relative;">
                  <img
                      v-if="!groupImage.backCMND"
                      src="@/assets/images/videoCall/back-card.png"
                      class="video-image"
                  />
                  <!--                  <img v-if="groupImage.backCMND" :src="groupImage.backCMND"-->
                  <!--                       class="video-image preview-image" :class="invalidInfo.backCMND ? 'border-red' : ''"/>-->
                  <div class="image-container" v-if="groupImage.backCMND">
                    <v-zoomer>
                      <img
                          class="video-image preview-image image-zoom1"
                          :src="groupImage.backCMND"
                      />
                    </v-zoomer>
                    <div class="image-details1"></div>
                  </div>
                  <img
                      src="@/assets/images/videoCall/camera.svg"
                      alt=""
                      class="camera-icon"
                      @click="captureScreen('backCMND')"
                  />
                </div>
                <div class="text-label">Ảnh mặt sau</div>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="card-image-container mt-0">
                <img
                    v-if="!cardInfo.signData"
                    src="@/assets/images/videoCall/avatar.png"
                    class="video-image"
                />
                <img
                    v-if="cardInfo.signData"
                    :src="
                    cardInfo.signData.includes('data:image')
                      ? cardInfo.signData
                      : 'data:image/jpg;base64,' + cardInfo.signData
                  "
                    class="video-image preview-image"
                />
                <div class="text-label">Ảnh chữ ký</div>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="loadingHandleCard" class="mt-2">
            <b-col cols="12" class="d-flex align-items-center">
              <b-spinner variant="primary"/>
              <span class="ml-2">Đang xử lý</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="7">
          <validation-observer ref="videoForm" class="row register-data-form">
            <b-col cols="12">
              <b-form-group label="Nguồn" label-cols="4">
                <b-form-input :value="callSrc" size="md" type="text" disabled/>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Kênh" label-cols="4">
                <b-form-input
                    :value="cardInfo.channel"
                    size="md"
                    type="text"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="phone"
              >
                <b-form-group label="Số thuê bao" label-cols="4">
                  <b-form-input
                      v-model="cardInfo.telNumber"
                      size="md"
                      type="text"
                      disabled
                  />
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Số thuê bao không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  :rules="isUpdate ? '' : 'required'"
                  name="serial"
              >
                <b-form-group label="Số serial" label-cols="4">
                  <b-form-input
                      v-model="cardInfo.serial"
                      size="md"
                      type="text"
                      disabled
                  />
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Số serial không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group label="Đối tượng sử dụng" label-cols="4">
                  <b-form-input
                      disabled
                      value="Bản thân"
                      size="md"
                      type="text"
                  />
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Đối tượng sử dụng không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" class="text-primary mb-1">
              <div class="d-flex justify-content-center align-items-baseline">
                <i
                    class="fa-solid fa-triangle-exclamation mr-2"
                    style="color: #ff0000;font-size: 1.5rem"
                ></i>
                <b>PHẢI ĐẢM BẢO ĐÚNG THÔNG TIN NHƯ ẢNH GIẤY TỜ</b>
              </div>
            </b-col>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group label="Loại giấy tờ" label-cols="4">
                  <select
                      class="form-control"
                      v-model="cardInfo.cardType"
                      @change="handleChangeInfo"
                  >
                    <option value="1">CMT</option>
                    <option value="45">CCCD</option>
                    <option value="47">Căn Cước</option>
                  </select>
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Loại giấy tờ không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="idCard"
              >
                <b-form-group label="Số giấy tờ" label-cols="4">
                  <b-form-input
                      @change="handleChangeInfo"
                      v-model="cardInfo.idCard"
                      size="md"
                      type="text"
                      ref="idCardInput"
                      class="input_alarm"
                  />
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Số giấy tờ không được để trống</small
                    >
                    <small class="font-weight-bold" v-if="isErrorCardId"
                    >SAI ĐỊNH DẠNG SỐ, KIỂM TRA LẠI NGAY</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group label="Số hộ chiếu" label-cols="4">
                  <b-form-input
                      size="md"
                      type="text"
                      @change="handleChangeInfo"
                  />
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Số hộ chiếu không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="name"
              >
                <b-form-group label="Họ và tên" label-cols="4">
                  <b-form-input
                      v-model="cardInfo.name"
                      size="md"
                      type="text"
                      @change="handleChangeInfo"
                      ref="nameInput"
                      class="input_alarm"
                      style=" line-height: 3rem;"
                  />
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Họ và tên không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="dob"
              >
                <b-form-group label="Ngày sinh" label-cols="4">
                  <b-form-input
                      v-model="cardInfo.dob"
                      size="md"
                      type="text"
                      @change="handleChangeInfo"
                      ref="dobInput"
                  />
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Ngày sinh không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="gender"
              >
                <b-form-group label="Giới tính" label-cols="4">
                  <select
                      class="form-control"
                      v-model="cardInfo.gender"
                      @change="handleChangeInfo"
                  >
                    <option value="male">Nam</option>
                    <option value="female">Nữ</option>
                  </select>
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Giới tính không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="address"
              >
                <b-form-group label="Địa chỉ" label-cols="4">
                  <b-form-textarea
                      @change="handleChangeInfo"
                      v-model="cardInfo.address"
                      size="md"
                      type="text"
                      class="input_alarm"
                  />
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Địa chỉ không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="issueDate"
              >
                <b-form-group label="Ngày cấp" label-cols="4">
                  <b-form-input
                      @change="handleChangeInfo"
                      v-model="cardInfo.issueDate"
                      size="md"
                      class="input_alarm"
                      type="text"
                      ref="issueDateInput"
                  />
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Ngày cấp không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="issueAt"
              >
                <b-form-group label="Nơi cấp" label-cols="4">
                  <!--                  <b-form-input-->
                  <!--                    @change="handleChangeInfo"-->
                  <!--                    v-model="cardInfo.issueAt"-->
                  <!--                    size="md"-->
                  <!--                    type="text"-->
                  <!--                  />-->
                  <select
                      v-model="cardInfo.issueAt"
                      @change="handleChangeInfo"
                      class="form-control"
                  >
                    <option
                        v-for="place in issuedPlaceList"
                        :value="place.ISSUED_PLACE_CODE"
                    >{{ place.ISSUED_PLACE_NAME }}
                    </option>
                  </select>

                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Nơi cấp không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="nationality"
              >
                <b-form-group label="Quốc tịch" label-cols="4">
                  <b-form-input
                      @change="handleChangeInfo"
                      v-model="cardInfo.nationality"
                      size="md"
                      type="text"
                  />
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Quốc tịch không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Số liên hệ" label-cols="4">
                <b-form-input
                    v-model="cardInfo.contactPhone"
                    size="md"
                    type="text"
                    disabled
                />
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <button
                  :disabled="isDisableCheckC06"
                  @click="handleCheckC06()"
                  class="btn-video-call-action h-100 w-100"
              >
                2. Check C06
              </button>
            </b-col>
            <b-col cols="4">
              <button
                  @click="toggleShowSpecialCharModal()"
                  class="btn btn-info h-100 w-100"
              >
                Bảng ký tự đặc biệt
              </button>
            </b-col>
            <!-- <b-col cols="12" v-if="!cardInfo.signData" class="text-warning">
                Khách hàng chưa ký
            </b-col>
            <b-col v-else cols="12" class="text-success">
                <div class="text-signed" @click="$bvModal.show('modal-preview-sign')">
                    <img v-if="cardInfo.signData" src="../../../assets/images/icons/icon-tick.png"
                        style="width: 20px" />
                    Khách hàng đã ký
                </div>
            </b-col>-->
          </validation-observer>
          <b-row style="margin-top: 28px;">
            <b-col cols="12" class="font-medium-3 font-weight-bold"
            >Kết quả check C06
            </b-col>
            <b-col cols="12" class="text-primary mb-1" v-if="isErrorC06">
              <div class="d-flex align-items-baseline">
                <i
                    class="fa-solid fa-triangle-exclamation mr-2"
                    style="color: #ff0000;font-size: 1.5rem"
                ></i>
                <b>THUÊ BAO CHECK C06 CHƯA THÀNH CÔNG</b>
              </div>
            </b-col>
            <b-col cols="12">
              <table class="table border text-center">
                <thead>
                <tr>
                  <th>STT</th>
                  <th>Tên Trường</th>
                  <th>Kết quả</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(field, index) in c06Field">
                  <td class="border">{{ index + 1 }}</td>
                  <td class="border">{{ field.name }}</td>
                  <td class="border ">
                    {{
                      field.isChecked ? (field.status ? "Đúng" : "Sai") : ""
                    }}
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row style="margin-top: 28px;">
            <b-col cols="12">
              <div class="group-button-view">
                <!--            <div class="group-view-and-save">-->
                <!--              <button disabled @click="onRegisterContract()" class="btn-bg-green">-->
                <!--                Gửi KH xem phiếu-->
                <!--              </button>-->
                <!--              <button disabled class="btn-bg-red" @click="onSave()">-->
                <!--                Lưu-->
                <!--              </button>-->
                <!--            </div>-->
                <button
                    @click="onUpdateContract()"
                    class="btn-video-call-action h-100 w-100"
                    v-if="isUpdate"
                >
                  3. Xem phiếu
                </button>
                <button
                    @click="onRegisterContract()"
                    class="btn-video-call-action h-100 w-100"
                    v-else
                >
                  3. Xem phiếu
                </button>
                <button
                    class="btn-bg-green w-100"
                    @click="onUpdate()"
                    :disabled="isDisableRegister || isRejected"
                    v-if="isUpdate"
                >
                  4. Duyệt cập nhật
                </button>
                <button
                    v-else
                    class="btn-bg-green w-100"
                    @click="handleRegis"
                    :disabled="isDisableRegister || isRejected"
                >
                  4. Duyệt đăng ký
                </button>
                <div class="group-view-and-save">
                  <!--              <button disabled class="btn-border-red" @click="onWaitRegister()">-->
                  <!--                Chờ đăng ký-->
                  <!--              </button>-->
                  <button
                      class="btn-refuse "
                      @click="onRefuse()"
                      :disabled="isRejected"
                  >
                    Từ chối
                  </button>
                </div>
                <div>
                  <b-form-input
                      v-model="note"
                      size="md"
                      type="text"
                      placeholder="Ghi chú..."
                  />
                </div>
                <div class="group-view-and-save">
                  <button
                      class="btn btn-warning w-100"
                      @click="handleSaveNoteBtn()"
                      :disabled="note.length <= 0 || !cardInfo.telNumber"
                  >
                    Lưu ghi chú
                  </button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>

    <b-col md="5" sm="12" order="1" order-sm="1" order-md="2" v-if="isHasSign">
      <div class="video-container">
        <div class="top-video-container ">
          <div class="text-primary d-flex align-items-baseline">
            <button
                @click="RecordVideo()"
                class="btn-video-call-action mr-1"
                :class="isRecording ? 'btn-secondary' : 'btn-primary'"
            >
              {{ isRecording ? "1. Đang lưu video" : "1. Lưu video" }}
            </button>
            <b class="font-medium-2"
            >CHỈ BẤM LƯU VIDEO KHI KH BẮT ĐẦU ĐỌC STB</b
            >
          </div>
          <div class="font-medium-3 text-primary font-weight-bold ">
            {{
              callTime.minutes < 10 ? "0" + callTime.minutes : callTime.minutes
            }}:{{
              callTime.seconds < 10 ? "0" + callTime.seconds : callTime.seconds
            }}
          </div>
        </div>
        <div id="remoteTrack"></div>
        <div id="localTrack" class="local-track-container"></div>
        <!--        <img src="@/assets/images/videoCall/stop-call.svg" alt="" v-if="status == 'call'" class="image-stop-call"-->
        <!--             @click="stopCall()"/>-->
        <div class="group-button-call" v-if="status == 'call'">
          <button
              @click="onToggleMic()"
              class="btn btn-recorded-video ml-1"
              :class="isMicOn ? 'btn-success' : 'btn-primary'"
          >
            {{ isMicOn ? "Đang Bật Mic" : "Đang Tắt Mic" }}
          </button>
          <button
              class="image-stop-call btn btn-secondary ml-1"
              @click="stopCall()"
          >
            Ngắt kết nối
          </button>
        </div>
      </div>
      <div class="button-container mt-2">
        <!--        <div class="row mt-2">-->
        <!--          <b-col cols="4">-->
        <!--            <button disabled class="btn-video-call-action h-100 w-100" @click="captureScreen('profilePicture')">-->
        <!--              1. Chụp chân dung-->
        <!--            </button>-->
        <!--          </b-col>-->
        <!--          <b-col cols="4">-->
        <!--            <button disabled class="btn-video-call-action h-100 w-100" @click="captureScreen('frontCMND')">-->
        <!--              2. Chụp mặt trước-->
        <!--            </button>-->
        <!--          </b-col>-->
        <!--          <b-col cols="4">-->
        <!--            <button disabled class="btn-video-call-action h-100 w-100" @click="captureScreen('backCMND')">-->
        <!--              3. Chụp mặt sau-->
        <!--            </button>-->
        <!--          </b-col>-->
        <!--        </div>-->
        <div class="row mt-2 d-flex align-items-baseline px-1">
          <button
              @click="sendRequestRecordVideo()"
              class="btn-video-call-action mr-1"
          >
            Cho KH Quay Video
          </button>
          <b class="text-primary font-medium-1"
          >CHỈ BẤM NÚT NÀY KHI LỖI KHÔNG NÓI CHUYỆN/ NHÌN THẤY KH
          </b>
          <!--          <b-col cols="12" class="d-flex">-->
          <!--            <button @click="onRegisterContract()" class="btn-video-call-action h-100 w-100">-->
          <!--              Xem phiếu-->
          <!--            </button>-->
          <!--            <select v-model="mainCamera">-->
          <!--              <option v-for="cam in listCamera" :value="cam">{{ cam.label }}</option>-->
          <!--            </select>-->
        </div>
        <div class="row py-2">
          <!--                  <div class="col-6 border p-1 rounded-lg">-->
          <!--                    <VueSignaturePad-->
          <!--                      width="100%"-->
          <!--                      height="40vh"-->
          <!--                      ref="handWriteAdmin"-->
          <!--                      :options="options"-->
          <!--                    />-->
          <!--                    <div class="d-flex justify-content-center w-100 my-2 font-medium-2">-->
          <!--                      Chữ ký Admin-->
          <!--                    </div>-->
          <!--                    <div class="group-btn-action-modal-sign">-->
          <!--                      <button class="btn-action" @click="clearSign()">Ký lại</button>-->
          <!--                      <button-->
          <!--                        class="btn-action"-->
          <!--                        @click="confirm()"-->
          <!--                        :class="signDataAdmin ? 'btn-secondary' : ''"-->
          <!--                      >-->
          <!--                        {{ signDataAdmin ? "Đã xác nhận" : " Xác nhận" }}-->
          <!--                      </button>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <video controls playsinline id="videoRecorded" class="col-12"></video>
        </div>
      </div>
    </b-col>
    <div class="special-character-modal" v-if="isShowSpecialCharModal">
      <h3 class="text-center">BẢNG KÝ TỰ ĐẶC BIỆT</h3>
      <p>- Č /ch,ǯ/ và Ñ /nh/</p>
      <p>- J/dʒ/ và W/v/</p>
      <p>- Ă/ă:/ và Â/â:/,B/ᵽ/ và D/ᵵ/</p>
      <p>
        - Ƀ/b/, Č/ch,ǯ/, Ĕ/e:/, Ê̆/ê:/, Ĭ/i:/, Ñ/nh/, Ŏ/o:/, Ô̆/ô:/, Ơ̆/ơ:/, Ŭ/u:/,
        Ư̆/ư:/
      </p>
      <div class="d-flex justify-content-center">
        <button class="btn btn-info" @click="toggleShowSpecialCharModal">
          Đóng
        </button>
      </div>
    </div>

    <b-modal
        id="modal-contract"
        size="lg"
        :title="
        isUpdate
          ? 'Phiếu cập nhật thông tin thuê bao'
          : 'Phiếu đăng ký thông tin thuê bao'
      "
        hide-footer
    >
      <template>
        <b-row>
          <b-col cols="12" class="ml-auto">
            <img
                :src="prefixImgLink + contractBase64"
                class="video-image"
                alt="video-image"/>
            <!--            <embed :src="'data:application/pdf;base64,'+contractBase64" style="height: 80vh; width: 55vw">-->
          </b-col>
        </b-row>
        <hr/>
      </template>
    </b-modal>
    <b-modal id="modal-preview-sign" title="Chữ ký người dùng" hide-footer>
      <template>
        <b-row>
          <b-col cols="12" class="ml-auto">
            <img
                :src="
                cardInfo.signData.includes('data:image')
                  ? cardInfo.signData
                  : 'data:image/jpg;base64,' + cardInfo.signData
              "
                class="video-image"
            />
          </b-col>
        </b-row>
        <hr/>
      </template>
    </b-modal>

    <!--    <b-modal id="modal-sign-admin" title="Chữ ký admin" centered hide-footer>-->
    <!--      <template>-->
    <!--        <b-row>-->
    <!--          <b-col cols="12" class="ml-auto">-->
    <!--            <b-row class="p-1 f-flex justify-content-center">-->

    <!--            </b-row>-->
    <!--          </b-col>-->
    <!--        </b-row>-->
    <!--        <b-row scope-slot="modal-footer">-->
    <!--          <div class="group-btn-action-modal-sign">-->
    <!--            <button class="btn-action" @click="clearSign()">Ký lại</button>-->
    <!--            <button class="btn-action" @click="confirm()">Xác nhận</button>-->
    <!--          </div>-->
    <!--        </b-row>-->
    <!--      </template>-->
    <!--    </b-modal>-->

    <b-modal
        id="modal-incoming-call"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        centered
        hide-header
    >
      <template>
        <div class="incoming-call-container">
          <div class="d-flex justify-content-center align-items-center">
            <img src="@/assets/images/videoCall/icon-itel.png" alt=""/>
          </div>
          <div class="text-content">
            Bạn có cuộc gọi đến từ số thuê bao
            <span class="text-phone">{{ cardInfo.telNumber }}</span>
          </div>
          <button
              class="btn-accept-video-call"
              style="margin-top: 120px;"
              @click="acceptCall()"
          >
            Trả lời
          </button>
        </div>
      </template>
    </b-modal>
    <b-modal
        id="modal-ready"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        centered
        hide-header
    >
      <template>
        <div class="incoming-call-container">
          <div class="d-flex justify-content-center align-items-center">
            <img src="@/assets/images/videoCall/icon-itel.png" alt=""/>
          </div>
          <div v-if="isHasSign">
            <div class="text-content">
              Bấm nút "Sẵn sàng" bên dưới để bắt đầu tiếp nhận cuộc gọi
            </div>
            <button
                class="btn-accept-video-call"
                style="margin-top: 120px;"
                @click="handleClickReady()"
            >
              Sẵn sàng
            </button>
          </div>
          <div v-else>
            <div>
              <p class="text-content ">
                Bạn <span class="text-primary">chưa có chữ ký</span>, vui lòng <span class="text-primary">cập nhật chữ ký</span>
                trước khi tiếp nhận cuộc gọi.</p>
              <p class="text-content "> Nếu đã cập nhật vui lòng <span class="text-primary">đăng nhập</span> lại.</p>
              <button
                  class="btn-accept-video-call"
                  style="margin-top: 120px;"
                  @click="$bvModal.hide('modal-ready')"
              >
                Đóng
              </button>
            </div>

          </div>
        </div>
      </template>
    </b-modal>
    <!--    <b-modal-->
    <!--      id="modal-register"-->
    <!--      size="lg"-->
    <!--      hide-footer-->
    <!--      no-close-on-esc-->
    <!--      no-close-on-backdrop-->
    <!--      centered-->
    <!--      hide-header-->
    <!--    >-->
    <!--      <template>-->
    <!--        <div class="incoming-call-container">-->
    <!--          <div-->
    <!--            class="text-center text-primary font-large-1 font-weight-bold mb-2"-->
    <!--          >-->
    <!--            Thông báo-->
    <!--          </div>-->
    <!--          <div class="font-medium-2" style="color: black">-->
    <!--            <p>-->
    <!--              Bạn xác nhận KH đang-->
    <!--              <span class="font-weight-bold">KHÔNG SỬ DỤNG</span> số TB iTel nào-->
    <!--              trong danh sách.-->
    <!--            </p>-->
    <!--            <p>-->
    <!--              Nếu chọn "Đăng ký" các số TB gợi ý sẽ được đưa vào danh sách cần-->
    <!--              cập nhật lại TTTB.-->
    <!--            </p>-->
    <!--          </div>-->
    <!--          <div class="d-flex justify-content-around mt-3">-->
    <!--            <button-->
    <!--              class="btn btn-primary col-3 "-->
    <!--              @click="onUpdate"-->
    <!--              v-if="isUpdate"-->
    <!--            >-->
    <!--              Cập nhật-->
    <!--            </button>-->
    <!--            <button class="btn btn-primary col-3 " @click="onRegister" v-else>-->
    <!--              Đăng ký-->
    <!--            </button>-->
    <!--            <button class="btn btn-secondary col-3" @click="closeModalRegister">-->
    <!--              Quay lại-->
    <!--            </button>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </template>-->
    <!--    </b-modal>-->
    <!--    <b-modal-->
    <!--      id="modal-otp"-->
    <!--      size="lg"-->
    <!--      hide-footer-->
    <!--      no-close-on-esc-->
    <!--      no-close-on-backdrop-->
    <!--      centered-->
    <!--      hide-header-->
    <!--    >-->
    <!--      <template>-->
    <!--        <div class="incoming-call-container">-->
    <!--          <div-->
    <!--            class="text-center text-primary font-large-1 font-weight-bold mb-2"-->
    <!--          >-->
    <!--            Thông báo-->
    <!--          </div>-->
    <!--          <div class="font-medium-2" style="color: black">-->
    <!--            <p class="text-center">-->
    <!--              Hệ thống đã gửi OTP đến số thuê bao {{ sendOtpPhone }}-->
    <!--            </p>-->
    <!--            <p class="text-center">Mã OTP: {{ otpRegister }}</p>-->
    <!--            <div class="d-flex justify-content-center">-->
    <!--              <OtpInput-->
    <!--                v-model="otpRegister"-->
    <!--                ref="otpInput"-->
    <!--                separator=""-->
    <!--                input-classes="otp-input"-->
    <!--                :num-inputs="4"-->
    <!--              />-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="d-flex justify-content-around mt-3">-->
    <!--            <button class="btn btn-primary col-3 " @click="regisWithOtp">-->
    <!--              Đăng ký-->
    <!--            </button>-->
    <!--            <button class="btn btn-secondary col-3" @click="closeModalOTP">-->
    <!--              Quay lại-->
    <!--            </button>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </template>-->
    <!--    </b-modal>-->

    <audio ref="refPhoneRing" loop="true" allow="autoplay">
      <source src="../../../assets/audio/mixkit-old-telephone-ring-1357.wav"/>
    </audio>
    <!--    <iframe src="/videoCall/PhoneRing" allow="autoplay" class="hidden"></iframe>-->
    <input
        ref="inputUploadFile"
        type="file"
        hidden
        accept="image/png, image/jpeg"
        @change="captureFromUploadFile($event)"
    />
  </b-row>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "@validations";
import EventBus from "@/store/EventBus";
import Twilio, {createLocalAudioTrack, createLocalVideoTrack} from "twilio-video";
import {jwt} from "twilio";
import {BCol, BFormGroup, BFormInput, BFormTextarea, BInputGroup, BRow, BSpinner} from "bootstrap-vue";
import OtpInput from "@bachdgvn/vue-otp-input";
import useJwt from "@/auth/jwt/useJwt";
import io from "socket.io-client";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import {getUserData} from "@/auth/utils";
import _ from "lodash";
import axios from "axios";
import {$ctx} from "@themeConfig";
import {prefixImgLink} from "@/store/helper";

const AccessToken = jwt.AccessToken;
const VideoGrant = AccessToken.VideoGrant;

const CARD_TYPE = {
  CCCD: "45",
  CAN_CUOC: "47",
  CMT: "1",
  HO_CHIEU: "3"
};
const CARD_LENGTH = {
  CCCD: 12,
  CMT: 9
};

export default {
  name: "VideoCallContainer",
  data() {
    return {
      prefixImgLink,
      isShowSpecialCharModal: false,
      isDisableCheckC06: false,
      isRecordVideo: false,
      isErrorC06: false,
      isUpdateInfo: false,
      issuedPlaceList: [],
      isRejected: false,
      isUpdate: false,
      otpRegister: "",
      sendOtpPhone: "",
      c06Field: [
        {
          id: "idnumber_result",
          name: "Số giấy tờ",
          status: false,
          isChecked: false
        },
        {
          id: "name_result",
          name: "Họ và tên",
          status: false,
          isChecked: false
        },
        {
          id: "dob_result",
          name: "Ngày sinh",
          status: false,
          isChecked: false
        }
      ],
      options: {
        penColor: "rgb(56, 63, 255)",
        backgroundColor: "white"
      },
      status: "",
      isMicOn: true,
      isLoading: false,
      loadingHandleCard: false,
      data: {},
      videoEle: null,
      audioEle: null,
      localTrack: [],
      remoteTrack: [],
      remoteTrackWaiting: [],
      activeRoom: "",
      previewTracks: "",
      identity: "",
      roomName: null,
      captureScreenSrc: "",
      signDataAdmin: "",
      groupImage: {
        frontCMND: "",
        backCMND: "",
        profilePicture: ""
      },
      callId: "",
      username: "",
      nameGroupImage: {
        frontCMND: "Ảnh mặt trước",
        backCMND: "Ảnh mặt sau",
        profilePicture: "Ảnh chân dung"
      },
      cardInfo: {
        name: "",
        idCard: "",
        dueDate: "",
        dob: "",
        address: "",
        hometown: "",
        gender: "",
        issueDate: "",
        issueAt: "",
        telNumber: "",
        nationality: "",
        serial: "",
        signData: "",
        cardType: "",
        cityCode: "",
        contactPhone: "",
        faceMatching: "",
        posAgenId: "",
        channel: "",
        call_id: ""
      },
      callSrc: "",
      cardType: {
        1: "CMT",
        3: "HO_CHIEU",
        45: "CCCD",
        47: "CAN_CUOC"
      },
      matchInfo: {
        show: false,
        confidence: 0
      },
      invalidInfo: {
        frontCMND: false,
        backCMND: false,
        profilePicture: false
      },
      currentRoomId: "",
      socket: null,
      clientId: "",
      accessToken: "",
      required,
      contractBase64: "",
      infoAdmin: null,
      note: "",
      uploadType: "",
      ekycInvalidCodeMessage: {
        "err-1":
            "Ảnh có dấu hiệu được chụp qua màn hình điện tử, Bạn vui lòng kiểm tra lại nhé",
        "err-2": "Ảnh giấy tờ tùy thân là bản photocopy",
        "err-3": "Trường id trên tài liệu được định dạng không chính xác",
        "err-4": "MRZ code trên passport không đúng format",
        "err-5": "Giấy tờ tùy thân bị cắt góc",
        "err-6": "Giấy tờ tùy thân chụp sát góc",
        "err-7": "Loại thẻ không đúng, có thể sai cả mặt trước và mặt sau",
        "err-99": "Ảnh chụp không hợp lệ"
      },
      faceMatchingInvalidCodeMessage: {
        "err-1":
            "Giấy tờ tùy thân không nguyên vẹn, Bạn vui lòng kiểm tra lại nhé!",
        "err-2":
            "Ảnh chụp giấy tờ không hợp lệ do bản photocopy, Bạn vui lòng thực hiện chụp ảnh từ giấy tờ tùy thân gốc nhé!",
        "err-3":
            "Ảnh chụp giấy tờ tùy thân đã bị lóa, Bạn vui lòng chụp lại nhé!",
        "err-4": "Ảnh giấy tờ tùy thân không có mặt",
        "err-5":
            "Ảnh chụp giấy tờ không tìm thấy khuôn mặt, Bạn vui lòng kiểm tra và thực hiện lại nhé!",
        "err-6":
            "Ảnh chân dung có nhiều hơn 1 khuôn mặt, Bạn vui lòng thực hiện lại nhé!",
        "err-7":
            "Ảnh chân dung không hợp lệ, Bạn vui lòng không đeo kính đen để chụp ảnh nhé!",
        "err-8":
            "Ảnh chân dung không hợp lệ, Bạn vui lòng không đội mũ để chụp ảnh nhé!",
        "err-9":
            "Ảnh chân dung không hợp lệ, Bạn vui lòng không đeo khẩu trang để chụp ảnh nhé!",
        "err-10":
            "Ảnh chụp giấy tờ không hợp lệ do được chụp từ màn hình, thiết bị khác. Bạn vui lòng kiểm tra và thực hiện lại nhé! ",
        "err-11":
            "Ảnh chân dung không hợp lệ, Bạn vui lòng chụp khuôn mặt gần hơn nhé!",
        "err-12":
            "Ảnh chân dung không hợp lệ, Bạn vui lòng chụp khuôn mặt xa hơn chút nhé!"
      },
      errorCodeMessage: {
        "err-1": "Ảnh giấy tờ không tồn tại",
        "err-2": "Hình ảnh là bản photocopy",
        "err-3": "Ảnh giấy tờ tùy thân có dấu hiệu giả mạo",
        "err-4": "Ảnh giấy tờ tùy thân không có mặt",
        "err-5": "Ảnh chân dung không có mặt",
        "err-6": "Ảnh chứa nhiều hơn một mặt người",
        "err-7": "Đeo kính đen",
        "err-8": "Đội mũ",
        "err-9": "Đeo khẩu trang",
        "err-10":
            "Ảnh chụp từ bức ảnh khác, màn hình thiết bị, bị mờ nhiễu hoặc có dấu hiệu gian lận",
        "err-11": "Mặt người trong ảnh quá nhỏ",
        "err-12": "Mặt người trong ảnh quá gần với lề",
        "err-13": "Ảnh chân dung có kính, mũ",
        "err-99": "Ảnh chụp không hợp lệ"
      },
      callTime: {
        minutes: 0,
        seconds: 0
      },
      callTimeInterval: null,
      APP_API_URL: $ctx.API_URL.includes("dev")
          ? "https://app.itel.dev/api/uat/"
          : "https://app.itel.vn/api/v3/",
      SOCKET_URL: $ctx.API_URL.includes("dev")
          ? "https://socket.itel.dev/"
          : "https://socket.itel.vn/",
      POS_API_URL: $ctx.API_URL.includes("dev")
          ? "https://pos.itel.dev/api/pos/"
          : "https://pos.itel.vn/api/pos/",
      URL_WEB_API: $ctx.API_URL.includes("dev")
          ? "https://itel.dev"
          : "https://itel.vn",
      isRecording: false,
      rotageInfo: {
        front: 0,
        back: 0
      },
      isBusy: false,
      isDisableRegister: false,
      listCamera: [],
      mainCamera: null,
      mainMic: null
    };
  },
  components: {
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BFormGroup,
    BSpinner,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    OtpInput
  },
  created() {
    window.addEventListener("beforeunload", this.leaveRoomIfJoined);
    window.addEventListener("beforeunload", this.stopCallBeforeUnload);
  },
  beforeDestroy() {
    this.leaveRoomIfJoined();
    this.stopCall();
  },
  mounted() {
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Vui lòng cấp quyền thông báo!",
          icon: "AlertTriangleIcon",
          variant: "warning"
        }
      });
    }
    this.$bvModal.show("modal-ready");
    if (!MediaRecorder.isTypeSupported("video/webm; codecs=vp9")) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Trình duyệt không hỗ trợ quay màn hình!",
          icon: "AlertTriangleIcon",
          variant: "success"
        }
      });
    }
    this.getIssuedPlace();
    this.infoAdmin = getUserData();
    //https://socket.itel.dev/
    this.handleSocket();
    this.currentRoomId = this.create_UUID();

    // this.acceptCall()

    //check permission cam mic
    let VueThis = this;
    navigator.permissions
        .query({name: "camera"})
        .then(function (resultCamera) {
          let permission = {
            camera: false,
            microphone: false
          };
          permission.camera = resultCamera.state === "granted";
          navigator.permissions
              .query({name: "microphone"})
              .then(function (resultMic) {
                permission.microphone = resultMic.state === "granted";
                //pick cam mic
                if (permission.camera && permission.microphone) {
                  VueThis.handlePickCam();
                } else {
                  navigator.mediaDevices
                      .getUserMedia({video: true, audio: true})
                      .then(async stream => {
                        console.log("no permission -->", stream);
                        await VueThis.handlePickCam();
                        //stop cam mic
                        stream.getTracks().forEach(track => {
                          track.stop();
                        });
                      })
                      .catch(err => {
                        console.log("err->>", err);
                        VueThis.$toast({
                          component: ToastificationContent,
                          props: {
                            title: "Không thể truy cập camera, mic!",
                            icon: "CheckSquareIcon",
                            variant: "warning"
                          }
                        });
                      });
                }
              });
        });
  },
  computed: {
    isShowFaceWarning() {
      return (
          parseInt(this.cardInfo.faceMatching) <= 60 &&
          parseInt(this.cardInfo.faceMatching) >= 40
      );
    },
    isSuccessC06() {
      return !(!this.c06Field[1].status && !this.c06Field[2].status);
    },
    isErrorCardId() {
      if (this.cardInfo.cardType == CARD_TYPE.CCCD) {
        return this.cardInfo.idCard.length !== CARD_LENGTH.CCCD;
      }
      if (this.cardInfo.cardType == CARD_TYPE.CMT) {
        return this.cardInfo.idCard.length !== CARD_LENGTH.CMT;
      }
      return false;
    },
    isHasSign() {
      return JSON.parse(localStorage.getItem("userData"))
          .signature !== ""
    }
  },
  watch: {
    remoteTrack(value) {
      let previewContainer = document.getElementById("remoteTrack");
      previewContainer.innerHTML = "";
      value.forEach(el => {
        const child = el.attach() ? el.attach() : null;
        if (child) {
          console.log("child --->", child);
          previewContainer.appendChild(child);
        }
      });
    },
    localTrack(value) {
      let previewContainer = document.getElementById("localTrack");
      previewContainer.innerHTML = "";
      value.forEach(el => {
        const child = el.attach() ? el.attach() : null;
        if (child) {
          previewContainer.appendChild(child);
        }
      });
    }
  },
  methods: {
    showNotification() {
      if (Notification.permission !== "granted") {
        Notification.requestPermission();
      } else {
        const options = {
          body: "Có cuộc gọi đến từ số thuê bao " + this.cardInfo.telNumber,
          title: "Thông báo",
          icon: "https://itel.vn/favicon.ico"
        };
        try {
          const notification = new Notification("Cảnh báo cuộc gọi", options);
          // console.log("showNotification", options);
          notification.onclick = function () {
            // window.open("http://localhost:8080/video-call");
            // open current tab when click
            window.focus();
          };
        } catch (err) {
          console.log("err Noti", err);
        }
      }
    },
    handleSocket() {
      this.socket = io(this.SOCKET_URL, {
        transports: ["websocket"]
        // allowUpgrades: false,
        // pingTimeout: 600000,
        // pingInterval: 300000
      });
      this.socket.on("connect", () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Đã kết nối với server!",
            icon: "CheckSquareIcon",
            variant: "success"
          }
        });
        if (!this.isBusy) {
          this.socket.emit("admin-check-in", {
            //nickname is unique
            // JSON.parse(localStorage.getItem("userData")).email/this.create_UUID()
            nickname: JSON.parse(localStorage.getItem("userData")).email,
            roomId: this.currentRoomId
          });
        }
      });

      this.socket.on("disconnect", () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Mất kết nối với server!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
      });

      this.socket.on("client-calling", data => {
        this.$refs.refPhoneRing.play();
        console.log("client-calling");
        this.status = "connecting";
        this.clientId = data.id;
        this.cardInfo.telNumber = data.data.telNumber;
        this.cardInfo.serial = data.data.serial;
        this.$bvModal.show("modal-incoming-call");
        this.showNotification();
        this.logTwilioConnect(
            data.data.telNumber,
            "client-calling socket.on",
            JSON.parse(localStorage.getItem("userData")).email,
            true,
            10
        );
      });

      this.socket.on("client-stop-call", data => {
        console.log("client-stop-call");
        this.status = "";
        this.onCancelIncomingCall();
        this.removeCall();
        window.location.reload();
      });

      this.socket.on("admin-set-token", data => {
        this.accessToken = data;
      });

      this.socket.on("client-send-sign", data => {
        this.cardInfo.signData = data.signData;
      });

      this.socket.on("client-send-response-capture-image", data => {
        if (data.imageType == "profilePicture") {
          this.groupImage.profilePicture = data.image;
        }
        if (data.imageType == "frontCMND") {
          this.groupImage.frontCMND = data.image;
          this.getInfoCard();
        }
        if (data.imageType == "backCMND") {
          this.groupImage.backCMND = data.image;
          this.getInfoCard();
        }

        if (this.groupImage.frontCMND && this.groupImage.profilePicture) {
          this.checkMatchCardAndProfilePicture();
        }

        console.log("client-send-response-capture-image ", data);
      });

      this.socket.on("client-registration-confirmation", data => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Khách hàng xác nhận đăng ký!",
            icon: "AlertTriangleIcon",
            variant: "success"
          }
        });
      });
    },
    handleClickReady() {
      this.socket.emit("admin-connect", {
        //nickname is unique
        // JSON.parse(localStorage.getItem("userData")).email/this.create_UUID()
        nickname: JSON.parse(localStorage.getItem("userData")).email,
        roomId: this.currentRoomId
      });
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Bắt đầu nhận cuộc gọi!",
          icon: "CheckSquareIcon",
          variant: "success"
        }
      });
      this.$bvModal.hide("modal-ready");
    },
    toggleShowSpecialCharModal() {
      this.isShowSpecialCharModal = !this.isShowSpecialCharModal;
    },
    getIssuedPlace() {
      useJwt
          .get("getIssuedPlace")
          .then(res => {
            this.issuedPlaceList = res.data.result;
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lấy danh sách nơi cấp thất bại!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    },
    sendRequestRecordVideo() {
      this.logTwilioConnect(
          this.cardInfo.telNumber,
          "sendRequestRecordVideo",
          JSON.parse(localStorage.getItem("userData")).email,
          true,
          11
      );
      setTimeout(() => {
        this.socket.emit("admin-start-recording", {
          id: this.clientId
        });
        this.stopCall();
      }, 1000);
    },
    async handlePickCam() {
      await navigator.mediaDevices.enumerateDevices().then(data => {
        console.table(data);
        data.forEach(item => {
          if (item.kind === "videoinput") {
            if (item.label.includes("OBS Virtual Camera")) {
              this.mainCamera = item;
            }
          }
          if (item.kind === "audioinput") {
            this.mainMic = item;
          }
        });
        if (!this.mainCamera) {
          const listCam = data.filter(item => item.kind === "videoinput");
          this.mainCamera = listCam[0];
        }
        console.log("main cam", this.mainCamera);
      });
    },
    handleCheckC06: _.throttle(function () {
      this.checkC06();
    }, 1000),
    checkC06() {
      if (!this.isRecordVideo) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng lưu video trước khi kiểm tra C06!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.isDisableCheckC06 = true;
      this.loading(true);
      this.c06Field.forEach(item => {
        item.status = false;
      });
      this.isErrorC06 = false;
      useJwt
          .post("check-info", {
            idNumber: this.cardInfo.idCard,
            phone: this.cardInfo.telNumber,
            birthDay: this.cardInfo.dob,
            fullName: this.cardInfo.name
          })
          .then(res => {
            this.isDisableCheckC06 = false;
            this.loading(false);
            if (!res.data.result) {
              if (res.data.code === 201) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "C06 Lỗi",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                this.isErrorC06 = true;
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Thông tin giấy tờ trùng khớp!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
              }
              this.c06Field.forEach(item => {
                item.status = true;
                item.isChecked = true;
              });
              this.$refs.idCardInput.state = true;
              this.$refs.nameInput.state = true;
              this.$refs.dobInput.state = true;
              this.$refs.idCardInput.disabled = true;
              this.$refs.nameInput.disabled = true;
              this.$refs.dobInput.disabled = true;
            }
          })
          .catch(err => {
            this.isDisableCheckC06 = false;
            this.loading(false);
            if (err.response) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title:
                      "Thông tin giấy tờ chưa khớp với cơ sở dữ liệu dân cư quốc gia, Vui lòng kiểm tra lại thông tin giấy tờ",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              if (err.response.data.result) {
                this.c06Field.forEach(item => {
                  item.isChecked = true;
                });
                if (err.response.data.result.idnumber_result == "true") {
                  this.c06Field[0].status = true;
                  this.$refs.idCardInput.state = true;
                } else {
                  this.$refs.idCardInput.state = false;
                }
                if (err.response.data.result.name_result == "true") {
                  this.c06Field[1].status = true;
                  this.$refs.nameInput.state = true;
                } else {
                  this.$refs.nameInput.state = false;
                }
                if (err.response.data.result.dob_result == "true") {
                  this.$refs.dobInput.state = true;
                  this.c06Field[2].status = true;
                } else {
                  this.$refs.dobInput.state = false;
                }
              }
            }
          });
    },
    handleChangeInfo() {
      this.isUpdateInfo = true;
      this.contractBase64 = "";
    },
    onToggleMic() {
      if (this.activeRoom) {
        this.isMicOn = !this.isMicOn;
        const localParticipant = this.activeRoom.localParticipant;

        // track show on gdv page
        const tracks = Array.from(localParticipant.audioTracks.values());
        tracks.forEach(audioTrack => {
          if (this.isMicOn) {
            audioTrack.track.enable();
          } else {
            audioTrack.track.disable();
          }
        });
      }
    },
    async RecordVideo() {
      let vueThis = this;
      if (document.getElementById("remoteTrack").children.length <= 0) {
        return;
      }
      this.isRecording = true;
      this.isRecordVideo = true;
      this.videoEle = document.getElementById("remoteTrack").children[1];
      this.audioEle = document.getElementById("remoteTrack").children[0];
      // Lấy video track từ video element
      const videoTrack = this.videoEle.captureStream().getVideoTracks()[0];

      // Lấy audio track từ audio element
      const audioTrack = this.audioEle.captureStream().getAudioTracks()[0];
      const mediaStream = new MediaStream([videoTrack, audioTrack]);
      const mediaRecorder = new MediaRecorder(mediaStream, {
        mimeType: "video/webm; codecs=vp9"
      });
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Bắt đầu ghi màn hình!",
          icon: "AlertTriangleIcon",
          variant: "success"
        }
      });
      mediaRecorder.start();
      setTimeout(() => {
        mediaRecorder.stop();
      }, 16000);
      mediaRecorder.addEventListener("dataavailable", event => {
        vueThis.saveRecordedVideo(event.data);
        document.getElementById("videoRecorded").src = URL.createObjectURL(
            event.data
        );
      });
    },
    saveRecordedVideo(video) {
      const formData = new FormData();
      formData.append("files", video);
      formData.append("id", this.callId);
      useJwt
          .post("save_video_1", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(res => {
            this.isRecording = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lưu video thành công!",
                icon: "AlertTriangleIcon",
                variant: "success"
              }
            });
          })
          .catch(err => {
            this.isRecording = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lưu video thất bại!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    },
    handleRegis: _.throttle(function () {
      this.onRegister();
    }, 1000),
    onRegister() {
      if (!this.isSuccessC06) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra thông tin C06!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!this.contractBase64) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng khởi tạo hợp đồng trước khi đăng ký!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!moment(this.cardInfo.issueDate, "DD/MM/YYYY", true).isValid()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Ngày cấp phải theo định dạng DD/MM/YYYY! VD(01/01/2001)",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!moment(this.cardInfo.dob, "DD/MM/YYYY", true).isValid()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Ngày sinh phải theo định dạng DD/MM/YYYY! VD(01/01/2001)",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.loading(true);
      this.isDisableRegister = true;
      const data = {
        subscribers: [
          {
            phone: this.cardInfo.telNumber.replace("84", "0"),
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        psNgaysinh: this.cardInfo.dob.replace(/-/g, "/"),
        psQuoctich: "232",
        psnoicap: this.cardInfo.issueAt,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate.replace(/-/g, "/"),
        psContactPhone: this.cardInfo.contactPhone,
        img1: this.groupImage.frontCMND
            ? this.groupImage.frontCMND
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        img2: this.groupImage.backCMND
            ? this.groupImage.backCMND
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        img3: this.groupImage.profilePicture
            ? this.groupImage.profilePicture
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        hd: this.contractBase64,
        call_id: this.cardInfo.call_id
      };
      if (this.note.length > 0) {
        this.saveNote();
      }
      if (this.callSrc === "WEB") {
        useJwt
            .post("pos_sub_registration", data, {
              timeout: 120000
            })
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.socket.emit("register-result", {
                  id: this.clientId,
                  isSuccess: true
                });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã đăng ký thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                this.isDisableRegister = false;
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Đăng ký thông tin lỗi!";
                // this.socket.emit("register-result", {
                //   id: this.clientId,
                //   isSuccess: false
                // });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              this.isDisableRegister = false;
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Đăng ký thông tin lỗi!";
              // this.socket.emit("register-result", {
              //   id: this.clientId,
              //   isSuccess: false
              // });
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
      if (this.callSrc === "POS") {
        axios
            .post(
                this.POS_API_URL + "pos_sub_registration_VD",
                {
                  agentCode: this.cardInfo.posAgenId,
                  ...data
                },
                {
                  timeout: 120000
                }
            )
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.socket.emit("register-result", {
                  id: this.clientId,
                  isSuccess: true
                });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã đăng ký thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                this.isDisableRegister = false;
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Đăng ký thông tin lỗi!";
                console.log(errText + " " + res?.data?.message);
                // this.socket.emit("register-result", {
                //   id: this.clientId,
                //   isSuccess: false
                // });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              this.isDisableRegister = false;
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Đăng ký thông tin lỗi!";
              // this.socket.emit("register-result", {
              //   id: this.clientId,
              //   isSuccess: false
              // });
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
      if (this.callSrc === "APP") {
        axios
            .post(
                this.POS_API_URL + "pos_sub_registration_VD",
                {
                  agentCode: this.cardInfo.posAgenId,
                  ...data
                },
                {
                  timeout: 120000
                }
            )
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.socket.emit("register-result", {
                  id: this.clientId,
                  isSuccess: true
                });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã đăng ký thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                this.isDisableRegister = false;
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Đăng ký thông tin lỗi!";
                console.log(errText + " " + res?.data?.message);
                // this.socket.emit("register-result", {
                //   id: this.clientId,
                //   isSuccess: false
                // });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              this.isDisableRegister = false;
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Đăng ký thông tin lỗi!";
              // this.socket.emit("register-result", {
              //   id: this.clientId,
              //   isSuccess: false
              // });
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
    },
    onUpdate() {
      if (!this.isSuccessC06) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra thông tin C06!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!this.contractBase64) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng khởi tạo hợp đồng trước khi cập nhật!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!moment(this.cardInfo.issueDate, "DD/MM/YYYY", true).isValid()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Ngày cấp phải theo định dạng DD/MM/YYYY! VD(01/01/2001)",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!moment(this.cardInfo.dob, "DD/MM/YYYY", true).isValid()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Ngày sinh phải theo định dạng DD/MM/YYYY! VD(01/01/2001)",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.loading(true);
      this.isDisableRegister = true;
      const data = {
        subscribers: [
          {
            phone: this.cardInfo.telNumber.replace("84", "0"),
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        psNgaysinh: this.cardInfo.dob.replace(/-/g, "/"),
        psQuoctich: "232",
        psnoicap: this.cardInfo.issueAt,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate.replace(/-/g, "/"),
        psContactPhone: this.cardInfo.contactPhone,
        img1: this.groupImage.frontCMND
            ? this.groupImage.frontCMND
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        img2: this.groupImage.backCMND
            ? this.groupImage.backCMND
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        img3: this.groupImage.profilePicture
            ? this.groupImage.profilePicture
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
        hd: this.contractBase64,
        call_id: this.cardInfo.call_id
      };
      if (this.note.length > 0) {
        this.saveNote();
      }

      if (this.callSrc === "WEB" || this.callSrc === "APP") {
        useJwt
            .post("pos_sub_update_info", data, {
              timeout: 120000
            })
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.socket.emit("register-result", {
                  id: this.clientId,
                  isSuccess: true
                });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã cập nhật thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                this.isDisableRegister = false;
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Cập nhật thông tin lỗi!";
                // this.socket.emit("register-result", {
                //   id: this.clientId,
                //   isSuccess: false
                // });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              this.isDisableRegister = false;
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Cập nhật thông tin lỗi!";
              // this.socket.emit("register-result", {
              //   id: this.clientId,
              //   isSuccess: false
              // });
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
      if (this.callSrc === "POS") {
        axios
            .post(
                this.POS_API_URL + "pos_sub_update_info_VD",
                {
                  agentCode: this.cardInfo.posAgenId,
                  ...data
                },
                {
                  timeout: 120000
                }
            )
            .then(res => {
              this.loading(false);
              if (res?.data?.code == 200) {
                this.socket.emit("register-result", {
                  id: this.clientId,
                  isSuccess: true
                });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Khách hàng đã cập nhật thành công!",
                    icon: "AlertTriangleIcon",
                    variant: "success"
                  }
                });
                // this.approveTel()
                this.updateStatusRegis();
              } else {
                this.isDisableRegister = false;
                const errText = res?.data?.message
                    ? res?.data?.message
                    : "Cập nhật thông tin lỗi!";
                // this.socket.emit("register-result", {
                //   id: this.clientId,
                //   isSuccess: false
                // });
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: errText,
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
              }
            })
            .catch(err => {
              this.loading(false);
              this.isDisableRegister = false;
              const errText = err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Cập nhật thông tin lỗi!";
              // this.socket.emit("register-result", {
              //   id: this.clientId,
              //   isSuccess: false
              // });
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            });
      }
    },
    saveLogCall() {
      this.loading(true);
      useJwt
          .post("save-log-video-call_gen_link", {
            address: this.cardInfo.address,
            birthDay: this.cardInfo.dob,
            card_type: this.cardInfo.cardType,
            fullName: this.cardInfo.name,
            gender: this.cardInfo.gender,
            idNumber: this.cardInfo.idCard,
            img1: this.groupImage.frontCMND,
            img2: this.groupImage.backCMND,
            img3: this.groupImage.profilePicture,
            img4: this.cardInfo.signData,
            international: this.cardInfo.nationality,
            issueDate: this.cardInfo.issueDate,
            issuePlace: this.cardInfo.issueAt,
            note: null,
            object: null,
            passport: null,
            phone: this.cardInfo.telNumber,
            seri: this.cardInfo.serial,
            status: null,
            tdv: JSON.parse(localStorage.getItem("userData")).email,
            contactPhone: this.cardInfo.contactPhone,
            homeTown: this.cardInfo.hometown,
            cityCode: this.cardInfo.cityCode,
            faceMatching: this.cardInfo.faceMatching,
            isUpdate: this.isUpdate ? 1 : null
          })
          .then(res => {
            if (res.data.code === 200) {
              this.callId = res.data.result.id;
            }
          })
          .catch(err => {
            console.log(err);
          });
    },
    approveTel() {
      useJwt
          .get("approve-msisdn/" + this.cardInfo.telNumber)
          .then(res => {
            if (res.data.code === 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Phê duyệt thành công!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });

              this.updateStatusRegis();
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: res.data.message ? res.data.message : "Phê duyệt lỗi!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Phê duyệt tin lỗi!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    },
    updateStatusRegis() {
      useJwt
          .post("update-status-regis", {
            name: this.cardInfo.name,
            msisdn: this.cardInfo.telNumber,
            source: "INCALL",
            call_id: this.cardInfo.call_id
          })
          .then(res => {
            if (res.data.code === 200) {
              // this.$bvModal.hide("modal-register");
              this.$bvModal.hide("modal-otp");
              this.isDisableRegister = true;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Cập nhật trạng thái thành công!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
            } else {
              this.isDisableRegister = false;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: res.data.message
                      ? res.data.message
                      : "Cập nhật trạng thái lỗi!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response.data.message
                    ? err.response.data.message
                    : "Cập nhật trạng thái lỗi!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    },
    async onRefuse() {
      // if(this.callSrc==='WEB') return
      if (this.note.length <= 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng nhập lý do từ chối!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      await useJwt
          .post("refuse/" + this.cardInfo.telNumber, {
            note: this.note
          })
          .then(res => {
            this.isDisableRegister = true;
            this.isRejected = true;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Đã từ chối thuê bao!",
                icon: "AlertTriangleIcon",
                variant: "success"
              }
            });
            this.socket.emit("admin-reject-client-registration", {
              id: this.clientId
            });
          })
          .catch(err => {
            this.isDisableRegister = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.message
                    ? err.response?.data?.message
                    : "Từ chối thuê bao thất bại! Vui lòng thử lại!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
    },
    async saveNote() {
      await useJwt
          .get(
              "update-note/" +
              this.cardInfo.call_id +
              "/" +
              this.cardInfo.telNumber,
              {
                params: {
                  msg: this.note
                }
              }
          )
          .then(res => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lưu ghi chú thành công",
                icon: "AlertTriangleIcon",
                variant: "success"
              }
            });
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lưu ghi chú thất bại",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          });
    },
    handleSaveNoteBtn() {
      if (this.note.length <= 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng nhập ghi chú",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
      } else {
        this.saveNote();
      }
    },
    onCancelIncomingCall() {
      this.$bvModal.hide("modal-incoming-call");
      this.$refs.refPhoneRing.pause();
    },
    async onRegisterContract() {
      // if (this.contractBase64) {
      //   this.$bvModal.show("modal-contract");
      //   return
      // }
      if (!this.isSuccessC06) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra thông tin C06!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!this.cardInfo.telNumber) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra số thuê bao!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!moment(this.cardInfo.issueDate, "DD/MM/YYYY", true).isValid()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Ngày cấp phải theo định dạng DD/MM/YYYY! VD(01/01/2001)",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!moment(this.cardInfo.dob, "DD/MM/YYYY", true).isValid()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Ngày sinh phải theo định dạng DD/MM/YYYY! VD(01/01/2001)",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }

      var validatePicture =
          this.groupImage.frontCMND &&
          this.groupImage.backCMND &&
          this.groupImage.profilePicture;
      if (!validatePicture) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra ảnh chụp!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }

      var validate = await this.$refs.videoForm.validate();
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }

      this.loading(true);
      useJwt
          .get("get-phone-in-idNumber/" + this.cardInfo.idCard)
          .then(async res => {
            if (res.data?.result?.result?.length >= 3) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Thuê bao đã được đăng ký 3 số thuê bao!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
              return;
            }
            const data = {
              subscribers: [
                {
                  phone: this.cardInfo.telNumber.replace("84", "0"),
                  seri: this.cardInfo.serial
                }
              ],
              psHoten: this.cardInfo.name,
              psCmnd: this.cardInfo.idCard,
              psNgaysinh: this.cardInfo.dob,
              psQuoctich: "232",
              psnoicap: this.cardInfo.issueAt,
              psdiachi: this.cardInfo.address,
              psGioiTinh: this.cardInfo.gender,
              ploaigt: this.cardInfo.cardType,
              psplacedate: this.cardInfo.issueDate,
              img1: this.groupImage.frontCMND,
              img2: this.groupImage.backCMND,
              img3: this.groupImage.profilePicture,
              psContactPhone: this.cardInfo.contactPhone,
              psHomeTown: this.cardInfo.hometown,
              psCityCode: this.cardInfo.cityCode,
              faceMatching: this.cardInfo.faceMatching,
              signatureImage: this.cardInfo.signData,
              agency_signatureImage: JSON.parse(localStorage.getItem("userData"))
                  .signature,
              tdv: JSON.parse(localStorage.getItem("userData")).fullName,
              call_id: this.cardInfo.call_id
            };
            if (this.isUpdateInfo) {
              await this.saveLogCall();
            }
            if (this.callSrc === "WEB") {
              useJwt
                  .postEx(
                      this.URL_WEB_API + "/api/web/pos_sub_registration_form_pdf",
                      data
                  )
                  .then(res => {
                    this.contractBase64 = res.data.result.img4_link;
                    this.$bvModal.show("modal-contract");
                    this.loading(false);
                  })
                  .catch(err => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                        icon: "AlertTriangleIcon",
                        variant: "warning"
                      }
                    });
                    this.loading(false);
                  });
            }
            if (this.callSrc === "POS") {
              useJwt
                  .postEx(this.POS_API_URL + "pos_sub_registration_form_VD", {
                    agentCode: this.cardInfo.posAgenId,
                    ...data
                  })
                  .then(res => {
                    this.contractBase64 = res.data.result.img4_link;
                    this.$bvModal.show("modal-contract");
                    this.loading(false);
                  })
                  .catch(err => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                        icon: "AlertTriangleIcon",
                        variant: "warning"
                      }
                    });
                    this.loading(false);
                  });
            }
            if (this.callSrc === "APP") {
              useJwt
                  .postEx(
                      this.URL_WEB_API + "/api/web/pos_sub_registration_form_APP",
                      data
                  )
                  .then(res => {
                    this.contractBase64 = res.data.result.img4_link;
                    this.$bvModal.show("modal-contract");
                    this.loading(false);
                  })
                  .catch(err => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                        icon: "AlertTriangleIcon",
                        variant: "warning"
                      }
                    });
                    this.loading(false);
                  });
            }
          })
          .catch(err => {
            this.loading(false);
          });
    },
    async onUpdateContract() {
      // if (this.contractBase64) {
      //   this.$bvModal.show("modal-contract");
      //   return
      // }
      if (!this.cardInfo.telNumber) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra số thuê bao!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!this.isSuccessC06) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra thông tin C06!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      // if (!this.signDataAdmin) {
      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Vui lòng kiểm tra chữ ký admin!",
      //       icon: "AlertTriangleIcon",
      //       variant: "warning"
      //     }
      //   });
      //   return;
      // }
      if (!moment(this.cardInfo.issueDate, "DD/MM/YYYY", true).isValid()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Ngày cấp phải theo định dạng DD/MM/YYYY! VD(01/01/2001)",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!moment(this.cardInfo.dob, "DD/MM/YYYY", true).isValid()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Ngày sinh phải theo định dạng DD/MM/YYYY! VD(01/01/2001)",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      var validatePicture =
          this.groupImage.frontCMND &&
          this.groupImage.backCMND &&
          this.groupImage.profilePicture;
      if (!validatePicture) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra ảnh chụp!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      var validate = await this.$refs.videoForm.validate();
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.loading(true);
      const data = {
        subscribers: [
          {
            phone: this.cardInfo.telNumber.replace("84", "0"),
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        psNgaysinh: this.cardInfo.dob,
        psQuoctich: "232",
        psnoicap: this.cardInfo.issueAt,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate,
        img1: this.groupImage.frontCMND,
        img2: this.groupImage.backCMND,
        img3: this.groupImage.profilePicture,
        signatureImage: this.cardInfo.signData,
        psContactPhone: this.cardInfo.contactPhone,
        psHomeTown: this.cardInfo.hometown,
        psCityCode: this.cardInfo.cityCode,
        faceMatching: this.cardInfo.faceMatching,
        agency_signatureImage: JSON.parse(localStorage.getItem("userData"))
            .signature,
        tdv: JSON.parse(localStorage.getItem("userData")).fullName,
        call_id: this.cardInfo.call_id
      };
      if (this.isUpdateInfo) {
        await this.saveLogCall();
      }
      if (this.callSrc === "WEB") {
        useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_update_info_form_pdf",
                data
            )
            .then(res => {
              this.contractBase64 = res.data.result.img4_link;
              this.$bvModal.show("modal-contract");
              this.loading(false);
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      if (this.callSrc === "APP") {
        useJwt
            .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_update_info_form_pdf_APP",
                data
            )
            .then(res => {
              this.contractBase64 = res.data.result.img4_link;
              this.$bvModal.show("modal-contract");
              this.loading(false);
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
      if (this.callSrc === "POS") {
        useJwt
            .postEx(this.POS_API_URL + "pos_sub_update_info_form_vd", {
              agentCode: this.cardInfo.posAgenId,
              ...data
            })
            .then(res => {
              this.contractBase64 = res.data.result.img4_link;
              this.$bvModal.show("modal-contract");
              this.loading(false);
            })
            .catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
              this.loading(false);
            });
      }
    },
    create_UUID() {
      let dt = new Date().getTime();
      let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            let r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
          }
      );
      return uuid;
    },
    stopCall() {
      this.status = "";
      this.socket.emit("admin-stop-call", {
        id: this.clientId,
        roomId: this.currentRoomId,
        SID: this.activeRoom.sid
      });
      this.removeCall();
      window.location.reload();
    },
    stopCallBeforeUnload() {
      if (this.status && this.status.length > 0) {
        this.stopCall();
      }
    },
    removeCall() {
      this.ResetCountUpTime();
      this.localTrack.forEach(videoTrack => {
        const mediaElements = videoTrack.detach();
        mediaElements.forEach(mediaElement => mediaElement.remove());
      });
      // this.logEndTime()
      this.leaveRoomIfJoined();
      this.remoteTrack = [];
      this.localTrack = [];
      this.activeRoom = null;
    },
    refuseCall() {
      this.$bvModal.hide("modal-incoming-call");
      this.$refs.refPhoneRing.pause();
      this.socket.emit("admin-refuse-call", {
        id: this.clientId,
        roomId: this.currentRoomId
      });
      this.status = "";
      this.remoteTrack = [];
    },
    ResetCountUpTime() {
      clearInterval(this.callTimeInterval);
      this.callTime.minutes = 0;
      this.callTime.seconds = 0;
    },
    CountUpTime() {
      this.callTimeInterval = setInterval(() => {
        this.callTime.seconds++;
        if (this.callTime.seconds === 60) {
          this.callTime.minutes++;
          this.callTime.seconds = 0;
        }
      }, 1000);
    },
    acceptCall() {
      this.loading(true);
      this.isBusy = true;
      this.$bvModal.hide("modal-incoming-call");
      this.$refs.refPhoneRing.pause();
      this.status = "call";
      this.logTwilioConnect(
          this.cardInfo.telNumber,
          "client-calling acceptCall",
          JSON.parse(localStorage.getItem("userData")).email,
          true,
          11
      );
      this.createChat(this.currentRoomId);
      this.CountUpTime();
      // useJwt
      //   .postEx(this.APP_API_URL + "integration-api/pps/create-session", {
      //     phone087xx: this.cardInfo.telNumber,
      //     type: "dktttb"
      //   })
      //   .then(res => {
      //     console.log("res", res);
      //   })
      //   .catch(err => {
      //     console.log("err", err.response);
      //   });

      useJwt
          .get("get-info/" + this.cardInfo.telNumber)
          .then(res => {
            const data = res.data.result[0];
            this.callId = data.ID;
            this.cardInfo.serial = data.SERI;
            this.cardInfo.name = data.FULL_NAME;
            this.cardInfo.idCard = data.ID_NUMBER;
            this.cardInfo.dueDate = data.ISSUE_DATE;
            this.cardInfo.dob = data.BIRTH_DAY;
            this.cardInfo.address = data.ADDRESS;
            this.cardInfo.hometown = data.HOME_TOWN;
            this.cardInfo.nationality =
                data.INTERNATIONAL == 232 ? "Việt Nam" : "Việt Nam";
            this.cardInfo.gender = data.GENDER;
            this.cardInfo.issueDate = data.ISSUE_DATE;
            //check loai giay to
            if (data.CARD_TYPE == "CCCD") {
              this.cardInfo.cardType = CARD_TYPE.CCCD;
            } else if (data.CARD_TYPE == "CMT") {
              this.cardInfo.cardType = CARD_TYPE.CMT;
            } else {
              this.cardInfo.cardType = data.CARD_TYPE;
            }
            //check noi cap
            if (data.ISSUE_PLACE) {
              if (data.ISSUE_PLACE.length == 3) {
                this.cardInfo.issueAt = data.ISSUE_PLACE;
              } else {
                this.onCheckIssueAt(
                    data.ISSUE_PLACE,
                    this.cardInfo.cardType == "1"
                );
              }
            } else {
              this.cardInfo.issueAt = "";
            }

            this.groupImage.frontCMND = "data:image/jpeg;base64," + data.IMAGE1;
            this.groupImage.backCMND = "data:image/jpeg;base64," + data.IMAGE2;
            this.groupImage.profilePicture =
                "data:image/jpeg;base64," + data.IMAGE3;
            this.cardInfo.signData = "data:image/jpeg;base64," + data.IMAGE4;
            this.cardInfo.cityCode = data.CITY_CODE;
            this.cardInfo.contactPhone = data.CONTACT_PHONE;
            this.cardInfo.faceMatching = data.FACE_MATCHING
                ? data.FACE_MATCHING.slice(0, 4)
                : "";
            this.cardInfo.posAgenId = data.POS_AGEN_ID;
            this.cardInfo.channel = data.CHANEL;
            if (this.cardInfo.posAgenId && this.cardInfo.posAgenId.length > 0) {
              if (this.cardInfo.posAgenId == 0) {
                this.callSrc = "APP";
              } else {
                this.callSrc = "POS";
              }
            } else {
              this.callSrc = "WEB";
            }
            this.cardInfo.call_id = data.CALL_ID;
            this.isUpdate = data.IS_UPDATE === 1;
            this.loading(false);
            // this.getPhoneByIdNumber()
            // this.saveLogCall()
            if (!moment(this.cardInfo.issueDate, "DD/MM/YYYY", true).isValid()) {
              this.$refs.issueDateInput.state = false;
            }
            if (!moment(this.cardInfo.dob, "DD/MM/YYYY", true).isValid()) {
              this.$refs.dobInput.state = false;
            }
            if (this.cardInfo.cardType == CARD_TYPE.CMT) {
              if (this.cardInfo.idCard.length !== CARD_LENGTH.CMT) {
                this.$refs.idCardInput.state = false;
              }
            }
            if (this.cardInfo.cardType == CARD_TYPE.CCCD) {
              if (this.cardInfo.idCard.length !== CARD_LENGTH.CCCD) {
                this.$refs.idCardInput.state = false;
              }
            }
            setTimeout(() => {
              // new Drift(document.querySelector(".image-zoom"), {
              //   paneContainer: document.querySelector(".image-details"),
              //   zoomFactor: 4
              // });
              // new Drift(document.querySelector(".image-zoom1"), {
              //   paneContainer: document.querySelector(".image-details1"),
              //   zoomFactor: 4
              // });
              this.$refs.videoForm.validate();
            }, 2000);
          })
          .catch(err => {
            this.loading(false);
            console.log("err", err);
          });
    },
    // Generate access token
    // Trigger log events
    dispatchLog(message) {
      EventBus.$emit("new_log", message);
    },
    // Leave Room.
    leaveRoomIfJoined() {
      if (this.activeRoom) {
        this.activeRoom.disconnect();
      }
      this.isBusy = false;
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async captureFromUploadFile(e) {
      this.loading(true);
      if (!e.target.files) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Chưa chọn ảnh!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        this.loading(false);
        return;
      }
      const file = await this.toBase64(e.target.files[0]);
      this.groupImage = {...this.groupImage, [this.uploadType]: file};
      this.loading(false);
      this.getRegistrationFormInfo();
    },
    captureScreen(imageType) {
      let previewContainer = document.getElementById("remoteTrack");
      console.log("previewContainer", previewContainer.children);

      if (previewContainer.children && previewContainer.children.length > 0) {
        let canvas = document.createElement("canvas");
        let video = previewContainer.children[0];
        if (video.tagName.toLowerCase() != "video") {
          for (let i = 1; i < previewContainer.children.length; i++) {
            if (previewContainer.children[i].tagName.toLowerCase() == "video") {
              video = previewContainer.children[i];
            }
          }
        }
        if (video && video.tagName.toLowerCase() == "video") {
          canvas.width = video.clientWidth;
          canvas.height = video.clientHeight;

          let ctx = canvas.getContext("2d");
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          let image = canvas.toDataURL("image/jpeg");

          this.groupImage = {...this.groupImage, [imageType]: image};
        }

        this.getRegistrationFormInfo();
      }
    },
    async onCheckIssueAt(issueAt, isCMT) {
      this.loading(true);
      const params = {
        type: isCMT ? "CMT" : "CCCD",
        placeName: issueAt
      };
      await useJwt
          .post(
              "issuedPlace",
              params
          )
          .then(
              response => {
                this.loading(false);
                // console.log("response --->", response);
                this.cardInfo.issueAt = response.data.data.onSelect.issuedPlaceCode;
              },
              error => {
                this.loading(false);
                console.log("error", error);
              }
          );
    },
    getRegistrationFormInfo() {
      this.c06Field.forEach(item => {
        item.status = false;
      });
      if (this.groupImage.frontCMND || this.groupImage.backCMND) {
        this.getInfoCard();
      }
      if (this.groupImage.frontCMND && this.groupImage.profilePicture) {
        this.checkMatchCardAndProfilePicture();
      }
    },
    async getInfoCard() {
      this.loadingHandleCard = true;
      this.loading(true);
      this.handleChangeInfo();
      useJwt
          .post("ovs/ekyc/cards?format_type=base64&get_thumb=false", {
            img1: this.groupImage.frontCMND
                ? this.groupImage.frontCMND
                    .replace("data:image/jpeg;base64,", "")
                    .replace("data:image/png;base64,", "")
                    .replace("data:image/jpg;base64,", "")
                : null,
            img2: this.groupImage.backCMND
                ? this.groupImage.backCMND
                    .replace("data:image/jpeg;base64,", "")
                    .replace("data:image/png;base64,", "")
                    .replace("data:image/jpg;base64,", "")
                : null
          })
          .then(response => {
            this.loading(false);
            this.loadingHandleCard = false;
            let data = response.data?.result?.data || [];
            if (data && data.length > 0) {
              data.forEach(el => {
                if (el.type == "chip_id_card_front") {
                  this.cardInfo = {
                    ...this.cardInfo,
                    name: el.info.name,
                    idCard: el.info.id,
                    dueDate: el.info.due_date,
                    dob: el.info.dob,
                    address: el.info.address,
                    hometown: el.info.hometown,
                    gender: el.info.gender == "nam" ? "male" : "female",
                    nationality: el.info.nationality,
                    cardType: CARD_TYPE.CCCD,
                    cityCode: el.info.address_town
                  };
                  if (el.valid == "False") {
                    this.invalidInfo = {
                      ...this.invalidInfo,
                      frontCMND: true
                    };
                  } else {
                    this.invalidInfo = {
                      ...this.invalidInfo,
                      frontCMND: false
                    };
                  }
                }
                if (el.type == "9_id_card_front") {
                  this.cardInfo = {
                    ...this.cardInfo,
                    name: el.info.name,
                    idCard: el.info.id,
                    // dueDate: el.info.due_date,
                    dob: el.info.dob,
                    address: el.info.address,
                    hometown: el.info.hometown,
                    // gender: el.info.gender,
                    cardType: "1",
                    cityCode: el.info.address_town
                  };
                  if (el.valid == "False") {
                    this.invalidInfo = {
                      ...this.invalidInfo,
                      frontCMND: true
                    };
                  } else {
                    this.invalidInfo = {
                      ...this.invalidInfo,
                      frontCMND: false
                    };
                  }
                }
                if (el.type == "9_id_card_back") {
                  this.cardInfo = {
                    ...this.cardInfo,
                    issueDate: el.info.issue_date,
                    cardType: "1"
                  };
                  this.onCheckIssueAt(el.info.issued_at, true);

                  if (el.valid == "False") {
                    this.invalidInfo = {
                      ...this.invalidInfo,
                      backCMND: true
                    };
                  } else {
                    this.invalidInfo = {
                      ...this.invalidInfo,
                      backCMND: false
                    };
                  }
                }
                if (el.type == "chip_id_card_back") {
                  this.cardInfo = {
                    ...this.cardInfo,
                    issueDate: el.info.issue_date,
                    issueAt: "CQH",
                    cardType: CARD_TYPE.CCCD
                  };
                  if (el.valid == "False") {
                    this.invalidInfo = {
                      ...this.invalidInfo,
                      backCMND: true
                    };
                  } else {
                    this.invalidInfo = {
                      ...this.invalidInfo,
                      backCMND: false
                    };
                  }
                }
              });
            }

            if (data && data.invalidCode && data.invalidCode != 0) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: _.get(
                      this.ekycInvalidCodeMessage,
                      `err-${data.invalidCode}`,
                      data.invalidMessage || ""
                  ),
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }

            let errorCode = response.data?.result?.errorCode || "0";
            if (errorCode != "0") {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: _.get(
                      this.errorCodeMessage,
                      `err-${errorCode}`,
                      response.data?.result?.errorMessage || ""
                  ),
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lỗi xử lý ảnh, vui lòng thử lại!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
            this.loadingHandleCard = false;
          });
    },
    async checkMatchCardAndProfilePicture() {
      this.loadingHandleCard = true;
      useJwt
          .post("ovs/ekyc/face_matching?format_type=base64&type1=card", {
            img1: this.groupImage.frontCMND
                ? this.groupImage.frontCMND
                    .replace("data:image/jpeg;base64,", "")
                    .replace("data:image/png;base64,", "")
                    .replace("data:image/jpg;base64,", "")
                : null,
            img2: this.groupImage.profilePicture
                ? this.groupImage.profilePicture
                    .replace("data:image/jpeg;base64,", "")
                    .replace("data:image/png;base64,", "")
                    .replace("data:image/jpg;base64,", "")
                : null
          })
          .then(response => {
            this.loadingHandleCard = false;
            let match = response.data?.result?.data?.match || 0;
            let matching = response.data?.result?.data?.matching || 0;

            let data = response.data?.result?.data || [];
            if (data && data.invalidCode && data.invalidCode != 0) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: _.get(
                      this.faceMatchingInvalidCodeMessage,
                      `err-${data.invalidCode}`,
                      data.invalidMessage || ""
                  ),
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }

            let errorCode = response.data?.result?.errorCode || "0";
            // if (errorCode != "0") {
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: _.get(
            //       this.errorCodeMessage,
            //       `err-${errorCode}`,
            //       response.data?.result?.errorMessage || ""
            //     ),
            //     icon: "AlertTriangleIcon",
            //     variant: "warning"
            //   }
            // });
            // }

            this.matchInfo = {
              ...this.matchInfo,
              show: true,
              confidence: matching
            };
            this.cardInfo.faceMatching = parseInt(matching);
            if (match == 1) {
              this.invalidInfo = {
                ...this.invalidInfo,
                profilePicture: false
              };
            } else {
              this.invalidInfo = {
                ...this.invalidInfo,
                profilePicture: true
              };
            }
          })
          .catch(err => {
            this.loadingHandleCard = false;
          });
    },

    async logTwilioConnect(phone, room, data, isSuccess, type = 2) {
      await useJwt
          .post("twilio-log", {
            phone: phone,
            room: room,
            data: isSuccess ? data : data.toString(),
            type: type
          })
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
    },
    // Create a new chat
    async createChat(room_name) {
      this.username = (Math.random() * 1000).toString();
      this.isLoading = true;
      this.isBusy = true;
      const VueThis = this;

      VueThis.roomName = null;
      const token = this.accessToken;
      if (!token) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi kết nối, vui lòng tải lại trang và thử lại!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      await createLocalAudioTrack()
          .then(track => {
            VueThis.localTrack.push(track);
          })
          .catch(err => {
            console.log("err createLocalAudioTrack", err);
          });
      await createLocalVideoTrack({
        deviceId: {
          exact: VueThis.mainCamera.deviceId,
          constraints: {
            width: {min: 640, ideal: 1080, max: 1920}, // Độ phân giải chiều rộng
            height: {min: 480, ideal: 1080, max: 1080}, // Độ phân giải chiều cao
            frameRate: {min: 15, ideal: 30, max: 60} // Tốc độ khung hình
          }
        }
      })
          .then(track => {
            VueThis.localTrack.push(track);
          })
          .catch(err => {
            console.log("err createLocalVideoTrack", err);
          });
      console.log("localTrack -->", VueThis.localTrack);
      let connectOptions = {
        name: room_name,
        audio: true,
        // video: { height: 720, frameRate: 24, width: 1280 },
        video: {
          frameRate: {min: 15, ideal: 30, max: 60},
          height: {min: 480, ideal: 480, max: 720},
          width: {min: 640, ideal: 640, max: 1280},
          preferredVideoCodecs: [{codec: "H264", simulcast: true}]
        },
        tracks: VueThis.localTrack,
        maxVideoBitrate: 2000000,
        maxAudioBitrate: 16000
      };
      // before a user enters a new room,
      // disconnect the user from they joined already
      this.leaveRoomIfJoined();

      // remove any remote track when joining a new room
      document.getElementById("remoteTrack").innerHTML = "";
      Twilio.connect(token, connectOptions)
          .then(function (room) {
            // console.log('Successfully joined a Room: ', room);
            console.log("room", room);
            VueThis.dispatchLog("Successfully joined a Room: " + room_name);
            // set active toom
            VueThis.activeRoom = room;
            VueThis.roomName = room_name;
            VueThis.isLoading = false;
            VueThis.isBusy = true;
            VueThis.socket.emit("admin-accept-call", {
              id: VueThis.clientId,
              roomId: VueThis.currentRoomId
            });
            VueThis.$toast({
              component: ToastificationContent,
              props: {
                title: "Bắt đầu kết nối video call!",
                icon: "AlertTriangleIcon",
                variant: "success"
              }
            });
            VueThis.logTwilioConnect(
                VueThis.cardInfo.telNumber,
                VueThis.currentRoomId,
                room,
                true
            );
            // Attach the Tracks of all the remote Participants.
            room.participants.forEach(function (participant) {
            });
            // When a Participant joins the Room, log the event.
            room.on("participantConnected", function (participant) {
              console.log("participantConnected", participant);
              VueThis.$toast({
                component: ToastificationContent,
                props: {
                  title: "Khách hàng đã tham gia cuộc gọi! ",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
              VueThis.dispatchLog("Joining: '" + participant.identity + "'");
            });

            room.on("trackStarted", function (track, participant) {
              console.log("trackStarted", participant, track);
              VueThis.dispatchLog(
                  participant.identity + " added track: " + track.kind
              );
              // VueThis.remoteTrack = [...VueThis.remoteTrack, track]
              VueThis.remoteTrack = [...VueThis.remoteTrack, track];
              VueThis.remoteTrack[0].setPriority("high");
            });

            room.on("trackUnpublished", function (publication, participant) {
              VueThis.remoteTrack = VueThis.remoteTrack.filter(
                  o => o.sid != publication.trackSid
              );
            });

            // When a Participant leaves the Room, detach its Tracks.
            room.on("participantDisconnected", function (participant) {
              VueThis.dispatchLog(
                  "Participant '" + participant.identity + "' left the room"
              );
              console.log("participant", participant, VueThis.remoteTrack);

              let tracks = Array.from(participant.tracks.values());
              tracks.forEach(el => {
                VueThis.remoteTrack = VueThis.remoteTrack.filter(
                    o => o.sid != el.trackSid
                );
              });
              console.log("VueThis.remoteTrack", VueThis.remoteTrack);
            });

            // if local preview is not active, create it

            if (!VueThis.localTrack || VueThis.localTrack.length == 0) {
              createLocalVideoTrack().then(track => {
                VueThis.localTrack = [track];
              });
            }
          })
          .catch(err => {
            console.log("err sasdasdas", err);
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                    "Lỗi kết nối video call, vui lòng kiểm tra lại cam, mic và kết nối mạng!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
            VueThis.logTwilioConnect(
                VueThis.cardInfo.telNumber,
                VueThis.currentRoomId,
                err,
                false
            );
          });
    }
  }
};
</script>
<style lang="scss" scoped>
.input_alarm {
  font-size: 1.3rem;
  color: #ed1e23;
  font-weight: bold;
}

.image-group {
  max-height: 100vh;
  overflow: auto;
}

.full-area-container {
  width: 100%;
  min-height: 300px;
}

.full-area {
  width: 100% !important;
  height: 100% !important;
  min-height: 300px;
}

.rotate-button-group {
  position: absolute;
  right: 50%;
  bottom: 14px;
  cursor: pointer;
  display: flex;
}

.rotate-button {
  margin: 4%;
  background: #494444;
  height: 20px;
  width: 20px;
}

.group-button-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 27px;

  button {
    padding: 15px 23px;
    border-radius: 10px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
    border: none;
    outline: none;
    width: fit-content;
  }

  .btn-bg-green {
    background: #17b51d;
    color: #fff;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .btn-bg-red {
    background: #ed1e23;
    color: #fff;

    &:disabled {
      background: #f1a9a9;
      cursor: not-allowed;
    }
  }

  .btn-border-red {
    color: #ed1e23;
    border: solid 1px #ed1e23;
    background: transparent;

    &:disabled {
      border: solid 1px #f1a9a9;
      background: #cacaca;
      cursor: not-allowed;
    }
  }

  .btn-refuse {
    background: #898c89;
    color: #fff;

    &:disabled {
      background: #666866;
      cursor: not-allowed;
    }
  }

  .group-view-and-save {
    display: flex;
    gap: 14px;

    .btn-bg-red {
      flex: auto;
    }

    .btn-refuse {
      flex: auto;
    }
  }
}

.card-image-container {
  margin-top: 65px;
  position: relative;

  .text-label {
    text-align: center;
    margin-top: 11px;

    color: #4b4b4b;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
  }

  .camera-icon {
    position: absolute;
    right: 21px;
    bottom: 14px;
    cursor: pointer;
  }
}

.video-container {
  // width: 720px;
  width: 100%;
  min-height: 500px;
  //max-height: 1280px;
  border: 1px solid #d9d9d9;
  position: relative;
  background: #ffffff;

  .group-button-call {
    position: absolute;
    width: 100%;
    bottom: 21px;
    z-index: 10;
    display: flex;
    justify-content: center;
  }

  .image-stop-call {
    //position: absolute;
    //bottom: 21px;
    //left: 60%;
    //transform: translateX(-50%);
    cursor: pointer;
  }

  .top-video-container {
    z-index: 10;
    position: absolute;
    top: 5px;
    padding: 0.3rem;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
}

.special-character-modal {
  right: 10%;
  z-index: 25 !important;
  width: 25%;
  padding: 1%;
  height: fit-content;
  position: fixed;
  background: white;
  border: 1px solid #434343;
  border-radius: 10px;
  box-shadow: 2px 5px 8px #888888;
}
</style>
<style lang="scss">
.checkbox-container:has(> input:disabled:checked)::after {
  width: 15px;
  height: 15px;
  font-size: 9px;
  background: #ed1e23;
  display: inline-block;
  border: 1px solid #ffffff;
  border-radius: 3px;
  color: white;
  position: relative;
  content: "✔";
  text-align: center;
  float: left;
  margin: 3px 4px 0 5px;
}

/* remove display of default disabled checked checkbox */
.checkbox-container input:disabled:checked {
  display: none;
}

.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;

  &.error {
    border: 1px solid red !important;
  }
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#modal-contract .modal-dialog {
  max-width: 50vw;
}

.group-btn-action-modal-sign {
  display: flex;
  padding: 0 12px;
  gap: 22px;
  width: 100%;

  .btn-action {
    flex: auto;
    padding: 13px 16px;
    border-radius: 10px;
    background: #ed1e23;
    border: none;
    outline: none;

    color: #fff;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}

.incoming-call-container {
  padding: 12px 24px;

  .text-content {
    margin-top: 35px;
    color: #666;
    font-size: 30px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    .text-phone {
      color: #fb1c1c;
    }
  }
}

.btn-video-call-action {
  padding: 13px 16px;
  border-radius: 10px;
  background: #ed1e23;
  border: none;
  outline: none;

  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  &:disabled {
    background: #f1a9a9;
    cursor: not-allowed;
  }
}

.btn-accept-video-call {
  padding: 13px 16px;
  border-radius: 10px;
  background: #17b51d;
  border: none;
  outline: none;

  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 100%;
}

.register-data-form {
  .form-row {
    legend {
      color: #4b4b4b;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
    }

    input.form-control {
      height: 36px;
      border-radius: 10px;
      border: 1px solid #d9d9d9;
    }
  }
}

.error-txt small {
  color: red;
}

.border-red {
  border: 1px solid #ff0000;
}

.row-gap-2 {
  row-gap: 2rem;
}

.btn-green {
  background: green;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 5px;
}

.video-image {
  width: 100%;
  height: max-content;
}

.min-height-150 {
  min-height: 150px;
}

/* .remote_video_container {
       margin: 0;
       border: 1px solid rgb(124, 129, 124);
       height: 100%;
       width: 100%;
       position: relative;
     } */
#remoteTrack video {
  margin: 0px;
  width: 100%;
  background-repeat: cover;
}

#remoteTrack {
  width: 100%;
}

.local-track-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 20%;
}

#localTrack video {
  border: 1px solid rgb(124, 129, 124);
  margin: 0px;
  width: 100%;
  height: 100%;
  background-repeat: cover;
}

.btn-capture {
  position: absolute;
  width: 40px;
  height: 40px;
  border: none;
  background: red;
  border-radius: 50%;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
}

.spacing {
  padding: 20px;
  width: 100%;
}

.roomTitle {
  border: 1px solid rgb(124, 129, 124);
  padding: 4px;
  color: dodgerblue;
}

.text-signed:hover {
  text-decoration: underline;
  cursor: pointer;
}

.border-green {
  border: 1px solid #00ff00;
}
</style>
